var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9992 16C31.9992 24.8367 24.8359 32 15.9992 32C7.16328 31.9992 0 24.8359 0 16C0 7.16328 7.16328 0 16 0C24.8367 0 32 7.16328 32 16H31.9992Z",
    fill: "#333D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3418 7.60742C22.5788 7.60761 24.3925 9.42218 24.3926 11.6592V20.3418C24.3923 22.5786 22.5787 24.3924 20.3418 24.3926H11.6592C9.42223 24.3925 7.60765 22.5787 7.60742 20.3418V11.6592C7.60747 9.42211 9.42212 7.60751 11.6592 7.60742H20.3418ZM11.9482 9.05469C10.3506 9.0548 9.05371 10.3515 9.05371 11.9492V20.0527C9.05396 21.6502 10.3507 22.9462 11.9482 22.9463H20.0518C21.6492 22.9462 22.946 21.6502 22.9463 20.0527V11.9492C22.9463 10.3516 21.6494 9.05481 20.0518 9.05469H11.9482ZM16.0078 11.6592C18.4036 11.6592 20.3485 13.6043 20.3486 16C20.3486 18.3958 18.4036 20.3408 16.0078 20.3408C13.6122 20.3406 11.668 18.3957 11.668 16C11.6681 13.6044 13.6123 11.6594 16.0078 11.6592ZM16.0078 13.1055C14.4136 13.1057 13.1144 14.4057 13.1143 16C13.1143 17.5944 14.4135 18.8943 16.0078 18.8945C17.6023 18.8945 18.9023 17.5945 18.9023 16C18.9022 14.4056 17.6023 13.1055 16.0078 13.1055ZM20.6396 10.5029C21.1179 10.503 21.5078 10.8928 21.5078 11.3711C21.5076 11.8492 21.1178 12.2392 20.6396 12.2393C20.1614 12.2393 19.7717 11.8493 19.7715 11.3711C19.7715 10.8927 20.1613 10.5029 20.6396 10.5029Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.43c7e6d899581dfbbed31baa049d3200.svg";
export { ForwardRef as ReactComponent };